/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fields: NonNullable<unknown> }} Tournament_New_Missing_FieldsInputs */



/**
* | output |
* | --- |
* | "Still needed: {fields}" |
*
* @param {Tournament_New_Missing_FieldsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_missing_fields = /** @type {((inputs: Tournament_New_Missing_FieldsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Missing_FieldsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Encore requis : ${i?.fields}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Aún se requiere: ${i?.fields}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Ainda necessário: ${i?.fields}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ancora necessario: ${i?.fields}`)
	return /** @type {LocalizedString} */ (`Still needed: ${i?.fields}`)
});